import { FC, useContext, useRef } from 'react';
import { WeChatModalProps } from '../../InternetBar.types';
import { Button } from '@marriott/mi-ui-library';
import { LOYALTY_URL } from '../../utils/constant';
import { PageParamsContext } from '../../../../modules/context/PageContext';
import { useRouter } from 'next/router';
import { isIOSCaptivePortal, navigateToWeChat, openWeChatScheme, sanitize } from '../../internetBar.helper';

export const InternetBarWeChatModal: FC<WeChatModalProps> = (props: WeChatModalProps) => {
  const { preProcessorResponse } = useContext(PageParamsContext);
  const { asPath } = useRouter();
  const weChatNoBtnRef = useRef(null);

  const weChatNoBtn = sanitize((props?.weChatNotInstalledButton ?? '').toString().replace(/<\/?p>/g, ''));
  const weChatYesBtn = sanitize((props?.weChatInstalledButton ?? '').toString().replace(/<\/?p>/g, ''));

  const navigateToWeChatClickHandler = () => {
    if (isIOSCaptivePortal()) {
      // Try to open WeChat. If installed, it will open. If not, nothing happens.
      openWeChatScheme(props?.weChatEnrollmentSourceCode);
    } else {
      navigateToWeChat(props?.weChatEnrollmentSourceCode);
    }
    props?.setShowWeChatModal(false);
  };

  const navigateToLoyaltyFlow = () => {
    const enrollmentSourceCode = props?.enrollmentSourceCode;
    let loyaltyURL = LOYALTY_URL;
    let urlQueryParams = '';
    const { dataLists } = props;
    const { segmentId = '', sourceSystem = '' } = dataLists;
    const srcSystem = sourceSystem ? `sourceSystem=${sourceSystem}&` : '';
    if (preProcessorResponse && preProcessorResponse?.enableLoyalty) {
      urlQueryParams = `?${srcSystem}enrollmentSourceCode=${enrollmentSourceCode}&returnToUrl=${encodeURIComponent(
        `${asPath}&ppv5Enrollment=true`
      )}`;
    } else {
      urlQueryParams = `?segmentId=${segmentId}&${srcSystem}enrollmentSourceCode=${enrollmentSourceCode}&returnToUrl=${encodeURIComponent(
        asPath
      )}`;
    }
    loyaltyURL += urlQueryParams;
    window.open(loyaltyURL, '_blank');
  };

  return (
    <div className="internetbar-wechat-container d-flex flex-column justify-content-center px-0 text-center align-items-center ">
      <span className={`t-accent-color icon-check icon-xxl`}></span>
      <p className="t-title-s mt-2 mb-0">{props?.weChatConnectLabel}</p>
      <p className="t-subtitle-l mt-4  mb-0">{props?.weChatHeading}</p>
      <p className="internetbar-wechat-container_description mt-2 mb-0">{props?.weChatDescription}</p>
      <p className="t-subtitle-m mt-4 mb-0">{props?.weChatInstalled}</p>
      <div className="internetbar-wechat-container_btns col-12 d-flex flex-row justify-content-around mt-4 mb-6 mx-3">
        <Button
          className={`internetbar-wechat-container_btn m-button m-button-primary`}
          custom_click_track_value="We Chat|Yes|external"
          data-custom_click_track_value="We Chat|Yes|external"
          data-is-click-track={true}
          isLink={false}
          callback={navigateToWeChatClickHandler}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: weChatYesBtn,
            }}
            className="m-0"
          ></p>
        </Button>
        <Button
          className={`internetbar-wechat-container_btn m-button m-button-secondary`}
          custom_click_track_value="We Chat|No|external"
          data-custom_click_track_value="We Chat|No|external"
          data-is-click-track={true}
          isLink={false}
          callback={navigateToLoyaltyFlow}
        >
          <p
            ref={weChatNoBtnRef}
            dangerouslySetInnerHTML={{
              __html: weChatNoBtn,
            }}
            className="m-0"
          ></p>
        </Button>
      </div>
    </div>
  );
};
